import React, { Component } from "react";
import styles from "./App.css";
import Nav from "./Nav";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Listings from "./Listings";
import Parking from "./Parking";
import emailIcon from "./email.svg";
import buildingIcon from "./building.svg";
import classNames from "classnames";

class App extends Component {
  render() {
    let homePage = () => (
      <div>
        <div className={styles["hero-image"]}>
          <img
            src="images/compressed/hayward-hero.jpg"
            alt="Historic Hayward Place condominiums and apartments in Lincoln, Nebraska."
          />
        </div>
        <hr />
        <div className={classNames(styles.amenities, styles.section)}>
          <h1 className={styles["section-header"]}>Amenities</h1>
          <div className={styles["amenities-list"]}>
            <div>
              <ul>
                <li>Private off-street parking</li>
                <li>Secure entry</li>
                <li>Individual heating and cooling</li>
              </ul>
            </div>
            <div>
              <ul>
                <li>In-building laundry</li>
                <li>Trash and recycling</li>
                <li>Basic cable</li>
              </ul>
            </div>
            <div>
              <ul>
                <li>14' ceilings</li>
                <li>10' windows</li>
                <li>New windows</li>
              </ul>
            </div>
          </div>
        </div>
        <hr />
        <div
          id="neighborhood"
          className={classNames(styles.neighborhood, styles.section)}
        >
          <h1 className={styles["section-header"]}>Neighborhood</h1>
          <p>
            A neighborhood landmark for nearly 100 years, Hayward Place is
            immediately recognizeable in Lincoln, Nebraska's North Bottoms
            district. Located within walking distance of the University of
            Nebraska-Lincoln campus, and with easy access to multiple bike paths
            on Lincoln's extensive trail network, it's easy to visit popular
            attractions nearby including the Railyard Entertainment District and
            Pinnacle Bank Arena in the Historic Haymarket, as well as Hawks
            Field. Just past the university's city campus lies the downtown bar
            and business districts.
          </p>
          <div className={styles["neighborhood-images"]}>
            <div>
              <img
                src="images/compressed/memorial-stadium.jpg"
                alt="The University of Nebraska - Lincoln's Memorial Stadium, filled to capacity on a game day."
              />
            </div>
            <div>
              <img
                src="images/compressed/themill-haymarket.jpg"
                alt="The Mill coffee house in the nearby Haymarket District."
              />
            </div>
            <div>
              <img
                src="images/compressed/unl-campus.jpg"
                alt="A student rests in a green space on the University of Nebraska - Lincoln's campus."
              />
            </div>
          </div>
        </div>
        <hr />
        <div
          id="history"
          className={classNames(styles.history, styles.section)}
        >
          <h1 className={styles["section-header"]}>History</h1>
          <p>
            Hayward School is the oldest surviving schoolhouse in the Lincoln
            Public School District. The building was named for U.S. Senator
            Monroe L. Hayward, a lawyer, farmer and stockraiser who died in
            1899. Hayward was used as school until 1968. In 1985, the building
            was sold and converted to condominiums.
          </p>
          <p>
            In the 1900s, half of the 4,000 German Russians in Lincoln lived in
            the North Bottoms neighborhood. Many of these immigrants - adults
            and children - worked in the sugar beet fields of central and
            western Nebraska. Hayward was the principal Lincoln school that
            served the needs of these immigrant children. According to an early
            Lincoln Public Schools' historian, "In November of each year the
            'beet field children' as they are called, return to Lincoln for the
            winter months and to attend school. Six new school rooms are opened
            for them and special teachers are employed for them. Over 300 are in
            attendance during the winter months. They return to the beet fields
            the first of May."
          </p>
          <div className={styles["history-images"]}>
            <div>
              <div>
                <img
                  src="images/compressed/hayward-before-construction.jpg"
                  alt="Hayward School prior to the construction of the third addition."
                />
              </div>
              <div>
                <img
                  src="images/compressed/students-at-hayward-school.jpg"
                  alt="Hayward School students posing outside. Writing reads 'The growing citizens. Better schools, better citizens.'"
                />
              </div>
              <div>
                <img
                  src="images/compressed/hayward-school-before-renovations.jpg"
                  alt="Hayward School students play outside the school, prior to the construction of the second and third additions."
                />
              </div>
            </div>
            <div>
              <div>
                <img
                  src="images/compressed/citizenship-class.jpg"
                  alt="Adults attend a citizenship course at Hayward School."
                />
              </div>
              <div>
                <img
                  src="images/compressed/hayward-school.jpg"
                  alt="Hayward School after the construction of the third addition."
                />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div
          id="parking"
          className={classNames(styles.parking, styles.section)}
        >
          <h1 className={styles["section-header"]}>Football Parking</h1>
          <div className={styles["parking-content"]}>
            <div className={styles["image-wrapper"]}>
              <img
                src="images/compressed/hayward-go-big-red.png"
                alt="Go Big Red"
              />
            </div>
            <div className={styles["parking-cta"]}>
              <div className={styles["cta-heading"]}>
                Minutes away from Memorial Stadium
              </div>
              <div className={styles["cta-subhead"]}>
                Park at Hayward Place this season
              </div>
              <a href="/footballparking">Learn more</a>
            </div>
          </div>
        </div>
        <hr />
        <div
          id="contact"
          className={classNames(styles.contact, styles.section)}
        >
          <h1 className={styles["section-header"]}>Contact</h1>
          <div className={styles.icons}>
            <div className={styles.icon}>
              <a
                className={styles["icon-link"]}
                href="mailto:contact@hayward.place"
              >
                <img src={emailIcon} alt="" />
                <span>contact@hayward.place</span>
              </a>
            </div>
            <div className={styles.icon}>
              <a className={styles["icon-link"]} href="/listings">
                <img src={buildingIcon} alt="" />
                <span>Rentals and Listings</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <Router>
        <div className={styles.App}>
          <Nav />
          <Route exact path="/" render={homePage} />
          <Route path="/listings" render={() => <Listings />} />
          <Route path="/footballparking" render={() => <Parking />} />
          <Route path="/register" component={() => { window.location.href = 'https://forms.gle/1S6b7qNfHkMzaT5S9'; return null; }} />
          <div className={styles.footer}>
            1223 N 9th Street Lincoln, NE 68508
          </div>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js